import { COOKIE_PREFIX, COOKIES_MAP, COOKIE_DURATION } from '../constans';

export function toQueryString(obj) {
    return Object.keys(obj)
        .map(key => {
            const escapedKey = escape(key);
            return `${encodeURIComponent(escapedKey)}=${encodeURIComponent(obj[escapedKey])}`;
        })
        .join('&');
}

export function getQueryParams(qs) {
    const params = {};
    let tokens;
    const re = /[?&]?([^=]+)=([^&]*)/g;

    qs = qs.split('?').pop();
    qs = qs.split('+').join(' ');

    while ((tokens = re.exec(qs))) {
        params[decodeURIComponent(escape(tokens[1]))] = decodeURIComponent(
            escape(encodeURIComponent(tokens[2]))
        );
    }

    return params;
}

export function hostFromUrl(url) {
    const fullUrl = url.indexOf('://') > -1;
    return url.split('/')[fullUrl ? 2 : 0];
}

export function parseUtm() {
    const utm = location.search
        .substring(1)
        .split('&')
        .reduce((acc, item) => {
            if (item.indexOf('utm_') === 0) {
                const temp = item.split('=');
                acc[temp[0]] = temp[1];
            }
            return acc;
        }, {});

    return utm;
}

// cookie utils
export function setCookie(name, value, seconds) {
    let expires;
    const date = new Date();

    if (seconds) {
        date.setTime(date.getTime() + seconds * 1000);
        expires = `; expires=${date.toGMTString()}`;
    } else {
        expires = '';
    }

    window.document.cookie = `${name}=${value}${expires}; path=/`;
}

export function getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = window.document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
}

export function deleteCookie(name) {
    setCookie(name, '', -1);
}

export function getCookieName(param) {
    return (COOKIES_MAP[param] && COOKIES_MAP[param].name) || `${COOKIE_PREFIX}${param}`;
}

export function getCookieDuration(param) {
    return (COOKIES_MAP[param] && COOKIES_MAP[param].duration) || COOKIE_DURATION;
}

// compound cookie utils
export function getCompoundCookie(name) {
    const value = getCookie(name);
    if (!value) return null;

    const segments = value.split('.');
    if (segments.length > 1 && !isNaN(segments.slice(-1)[0])) {
        const timeStamp = segments.pop();
        const date = new Date();
        date.setTime(timeStamp);

        return { value: segments.join('.'), date, full: value };
    }

    return { value, date: null, full: value };
}

// standardized cookie utils
export function parseStandardizedCookieValue(compoundValue) {
    if (compoundValue === undefined || compoundValue === null) return undefined;
    const version = compoundValue.substr(compoundValue.lastIndexOf(':') + 1);
    if (version === 'v1') {
        const segments = compoundValue.split(':').reverse();
        if (segments.length < 3)
            return {
                full: compoundValue,
                version: 'v1',
                error: '3 colon-separated segments expected'
            };
        const [_, timestamp, ...valueArray] = segments;
        const value = valueArray.reverse().join(':'); // rejoin if value includes any ':'
        const date = new Date();
        date.setTime(timestamp);
        if (isNaN(date.valueOf()))
            return {
                full: compoundValue,
                version: 'v1',
                error: 'Invalid timestamp format'
            };
        return {
            value,
            date,
            full: compoundValue,
            version: 'v1'
        };
    }

    return {
        full: compoundValue
    };
}

export function createStandardizedCookieValue(value, timestamp) {
    return value + ':' + String(timestamp || Date.now()) + ':v1';
}

export default {
    toQueryString,
    getQueryParams,
    parseUtm,
    hostFromUrl,
    setCookie,
    getCookie,
    getCompoundCookie,
    deleteCookie
};
